import type { NavIndicators } from "@/features/indicators/schemas/indicators.schema";
import { navIndicatorsSchema } from "@/features/indicators/schemas/indicators.schema";
import { apiCall } from "@/shared/lib/api-call";
import { apiPaths } from "@/shared/lib/api-paths";

export async function getNavIndicators(workspaceId: string): Promise<NavIndicators> {
  return apiCall<NavIndicators>(
    apiPaths.indicators.list(workspaceId),
    { method: "GET" },
    navIndicatorsSchema,
  );
}
